<template>
	<span class='loading line'></span>
</template>

<script>
	export default {
		
	}
</script>